<!-- 教育局-作业管理概览 -->
<template>
  <div class="container">
    <div class="index" v-show="!detail.show">
      <div class="title" style="text-align: center; width: 100%">
        <span style="font-weight: 500"
          >{{ org_type === "city" ? "武汉市" : "武昌区"
          }}{{ $route.name }}</span
        >
      </div>
      <div class="header-item-title m-l">
        <span class="circle"></span>
        <span>基本情况</span>
      </div>
      <div class="Homeboxtop_nav_tab m-t m-l">
        <span
          v-for="(item, index) in tabList"
          :class="['res-tab', { active: item.name === tabName }]"
          :key="index"
          @click="tabClick(item)"
        >
          {{ item.name }}
        </span>
      </div>
      <div class="header_num">
        <div class="header-item">
          <div class="header-item-smallTitle">
            <img src="./imgs/icon_1.png" alt="" />
            <span>学校作业公示情况</span>
          </div>
          <div class="header-item-box">
            <div class="box-right">
              <div>
                <p class="box-blue">{{ homeworkbaseData.recordNumber }}</p>
                <p class="w_100">参与备案学校总数</p>
              </div>
              <div>
                <p class="box-blue mr">
                  {{ homeworkbaseData.participationRate }}%
                </p>
                <p>参与率</p>
              </div>
            </div>
          </div>
        </div>
        <div class="header-item">
          <div class="header-item-smallTitle">
            <img src="./imgs/icon_1.png" alt="" />
            <span>学校作业反馈情况</span>
          </div>
          <div class="header-item-box">
            <div class="box-right">
              <div>
                <p class="box-blue">{{ feedbackbaseData.recordNumber }}</p>
                <p>
                  {{
                    org_type === "city"
                      ? "被反馈学校总数"
                      : "收到家长作业反馈学校总数"
                  }}
                </p>
              </div>
              <div>
                <p class="box-blue mr">
                  {{ feedbackbaseData.participationRate }}%
                </p>
                <p>参与率</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header>
        <div class="header-item">
          <div class="flex">
            <div class="header-item-title">
              <span class="circle"></span>
              <span
                >{{
                  org_type === "city" ? "各区域" : ""
                }}作业备案数情况统计</span
              >
            </div>

            <el-radio-group class="m-l" v-model="radio">
              <el-radio-button label="备案数前十名"></el-radio-button>
            </el-radio-group>
          </div>
          <div class="Homeboxtop_nav_tab m-t m-l m-b">
            <span
              v-for="(item, index) in tabList"
              :class="['res-tab', { active: item.name === tabName_1 }]"
              :key="index"
              @click="tabClick_1(item)"
            >
              {{ item.name }}
            </span>
          </div>

          <div id="echarts-box1" class="m-t"></div>
        </div>

        <div class="header-item" style="position: relative">
          <div class="header-item-title">
            <span class="circle"></span>
            <span
              >{{
                org_type === "city" ? "各区域" : "各校"
              }}作业平均完成时长前十</span
            >
          </div>
          <span class="unit">分钟</span>

          <div class="Homeboxtop_nav_tab m-t m-l m-b">
            <span
              v-for="(item, index) in tabList"
              :class="['res-tab', { active: item.name === tabName_2 }]"
              :key="index"
              @click="tabClick_2(item)"
            >
              {{ item.name }}
            </span>
          </div>
          <div id="echarts-box2" class="m-t"></div>
        </div>
      </header>

      <div class="header-item-title m-t">
        <span class="circle"></span>
        <span>实施情况</span>
      </div>

      <div class="Homeboxtop_nav_tab m-t">
        <span
          v-for="(item, index) in tabList"
          :class="['res-tab', { active: item.name === tabName3 }]"
          :key="index"
          @click="tabClick_3(item)"
        >
          {{ item.name }}
        </span>
      </div>

      <!-- 表格 -->
      <el-form
        ref="form"
        :inline="true"
        :model="form"
        label-width="70px"
        class="m-t"
      >
        <el-form-item label="区域名称" v-if="org_type === 'city'">
          <el-input placeholder="请输入区域名称"></el-input>
        </el-form-item>
        <el-form-item label="学校名称" v-if="org_type === 'area'">
          <el-input placeholder="请输入学校名称" v-model="orgName"></el-input>
        </el-form-item>

        <el-form-item label="" class="m-l">
          <el-button type="primary" size="small" @click="getDataList"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData.list"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            prop="areaName"
            label="区域"
            v-if="org_type === 'city'"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="orgName"
            label="学校"
            v-if="org_type === 'area'"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="registrations"
            label="作业登记数"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="recordNumber"
            label="作业备案总数"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="recordRate"
            label="作业备案率"
            :formatter="recordRateF"
          >
          </el-table-column>

          <el-table-column
            align="center"
            prop="avgExpect"
            label="作业平均预计完成时长"
            :formatter="avgExpectF"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="avgActual"
            label="作业平均完成时长"
            :formatter="avgActualF"
          >
          </el-table-column>
          <!-- <el-table-column align="center" label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="toDetail(scope)">查看</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="tableData.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="tableData.pageSize"
        :total="tableData.total"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail>
    <CityHome v-if="detail.show"></CityHome>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  feedbackbase,
  homeworkbase,
  homeworkrecord,
  implementationinfo,
  homeworkfeedback,
  cityFeedbackbase,
  cityHomeworkbase,
  cityHomeworkrecord,
  cityHomeworkfeedback,
  cityImplementationinfo,
} from "@/api/taskStatistics/index.js";
export default {
  components: {
    Detail: () => import("./detail.vue"),
    CityHome: () => import("./cityhome.vue"),
  },
  data() {
    return {
      feedbackbaseData: {
        recordNumber: 0,
        participationRate: 0,
      },
      homeworkbaseData: {
        recordNumber: 0,
        participationRate: 0,
      },
      homeworkrecordData: {
        recordNumber: 0,
        participationRate: 0,
      },
      radio:'备案数前十名',
      firstPamams: {
        loginPlatformCode: sessionStorage.loginPlatformCode,
        platformCode: sessionStorage.platformCode,
        usessionid: sessionStorage.usessionid,
        searchType: "week",
      }, //第一行三个请求参数是一致的
      orgName: "",
      form: {},
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      detail: {
        info: {},
        show: false,
        show_1: false,
        show_2: false,
      },
      tabList: [
        { name: "本周", label: "week" },
        { name: "本月", label: "month" },
        { name: "本学期", label: "semester" },
        { name: "本年度", label: "year" },
      ],
      tabName: "本周",
      tabName3: "本周",

      tu_1: {
        name: [
          "武汉小\n学",
          "武汉市\n武昌实\n验小学",
          "武汉大\n学第二\n附属小\n学",
          "湖北省\n武昌水\n果湖第\n二小学",
          "武汉大\n学附属\n小学",
          "武汉市\n中华路\n小学",
          "湖北省\n武昌水\n果湖第\n一小学",
          "武汉市\n南湖第\n二小学",
          "武汉市\n武昌区\n复兴路\n小学",
          "武汉市\n武昌区\n棋盘街\n小学",
        ],
        list: [2560, 2510, 2500, 2500, 2499, 2488, 2360, 2233, 2122, 2000],
      },
      tu_2: {
        name: [
          "武汉市\n武昌区\n八辅街\n小学",
          "武汉市\n三道街\n小学",
          "武汉市\n武昌区\n昙华林\n小学",
          "湖北省\n武昌水\n果湖第\n二小学",
          "武汉市\n梅苑学\n校小学\n部",
          "武汉市\n武昌区\n千家街\n小学",
          "武汉市\n南湖第\n一小学",
          "武汉市\n梨园小\n学",
          "武汉市\n武昌区\n余家头\n小学",
          "武汉市\n武昌区\n红岭小\n学",
        ],
        list: [95, 94, 84, 83, 80, 79, 60, 59, 55, 55, 53],
      },
      tabName_1: "本周",
      tabName_2: "本周",
    };
  },
  watch: {},
  computed: {
    // 教育局级别判断	省级:99  市级:1,10  区县级:2,20,4,40
    org_type() {
      let str = "area";
      if (sessionStorage.getItem("user_level") === "99") {
        str = "p";
      }
      if (["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1) {
        str = "city";
      }
      return str;
    },
  },
  mounted() {
    this.getHomeworkrecord();
    this.init();
  },
  created() {
    if (this.org_type === "city") {
      this.getCityFeedbackbase();
      this.getCityHomeworkbase();
      this.getCityImplementationinfo();
      this.getCityHomeworkfeedback();
    } else {
      this.getFeedbackbase();
      this.getHomeworkbase();
      this.getImplementationinfo();
      this.getHomeworkfeedback();
    }
  },
  methods: {
    recordRateF(row, column) {
      let data = (row.recordRate * 100).toFixed() + "%";
      return data;
    },
    avgExpectF(row, column) {
      let data = row.avgExpect.toFixed() + "分钟";
      return data;
    },
    avgActualF(row, column) {
      let data = row.avgActual.toFixed() + "分钟";
      return data;
    },
    //区级请求数据
    async getFeedbackbase(type) {
      this.firstPamams.searchType = type ? type : "week";
      const res = await feedbackbase(this.firstPamams);
      this.feedbackbaseData = res.data;
    },
    async getHomeworkbase(type) {
      this.firstPamams.searchType = type ? type : "week";
      const res = await homeworkbase(this.firstPamams);
      this.homeworkbaseData = res.data;
    },
    async getHomeworkrecord(type) {
      this.firstPamams.searchType = type ? type : "week";
      const res = await homeworkrecord(this.firstPamams);
      console.log(res);
      let XData = []
      let YData = []
      if(res.data&&res.data.length>0){
        res.data.map((item)=>{
          XData.push(item.orgName)
          YData.push(item.recordNumber)
        })
      }
        this.tu_1.name = XData,
        this.tu_1.list = YData
        this.init()
    },
    async getHomeworkfeedback(type) {
      this.firstPamams.searchType = type ? type : "week";
      const res = await homeworkfeedback(this.firstPamams);
      console.log(res);
            let XData = []
      let YData = []
      if(res.data&&res.data.length>0){
        res.data.map((item)=>{
          XData.push(item.orgName)
          YData.push(Number(item.recordNumber.toFixed()))
        })
      }
        this.tu_2.name = XData,
        this.tu_2.list = YData
        this.init()
    },
    async getImplementationinfo(type) {
      this.firstPamams.searchType = type ? type : "week";
      let params = {
        orgName: this.orgName,
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      let searchParams = {};
      Object.assign(searchParams, params, this.firstPamams);
      console.log(searchParams);
      const res = await implementationinfo(searchParams);
      // this.feedbackbaseData = res.data
      this.tableData = res.data;
      console.log(this.tableData);
    },
    //市级请求数据
    async getCityFeedbackbase(type) {
      this.firstPamams.searchType = type ? type : "week";
      const res = await cityFeedbackbase(this.firstPamams);
      this.feedbackbaseData = res.data;
    },
    async getCityHomeworkbase(type) {
      this.firstPamams.searchType = type ? type : "week";
      const res = await cityHomeworkbase(this.firstPamams);
      this.homeworkbaseData = res.data;
    },
    async getCityHomeworkrecord(type) {
      this.firstPamams.searchType = type ? type : "week";
      const res = await cityHomeworkrecord(this.firstPamams);
      // this.homeworkbaseData = res.data
      console.log(res);
    },
    async getCityHomeworkfeedback(type) {
      this.firstPamams.searchType = type ? type : "week";
      const res = await cityHomeworkfeedback(this.firstPamams);
      // this.homeworkbaseData = res.data
      console.log(res);
    },
    async getCityImplementationinfo(type) {
      this.firstPamams.searchType = type ? type : "week";
      let params = {
        areaCode: this.orgName,
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      let searchParams = {};
      Object.assign(searchParams, params, this.firstPamams);
      console.log(searchParams);
      const res = await cityImplementationinfo(searchParams);
      // this.feedbackbaseData = res.data
      this.tableData = res.data;
      console.log(this.tableData);
    },
    tabClick(item) {
      this.tabName = item.name;

      if (this.org_type === "city") {
        this.getCityFeedbackbase(item.label);
        this.getCityHomeworkbase(item.label);
      } else {
        this.getFeedbackbase(item.label);
        this.getHomeworkbase(item.label);
      }
    },
    tabClick_1(item) {
      this.tabName_1 = item.name;
      if (this.org_type === "city") {
        this.getCityHomeworkrecord(item.label);
      } else {
        this.getHomeworkrecord(item.label);
      }
    },
    tabClick_2(item) {
      this.tabName_2 = item.name;
      if (this.org_type === "city") {
        this.getCityHomeworkfeedback(item.label);
      } else {
        this.getHomeworkfeedback(item.label);
      }
    },
    tabClick_3(item) {
      this.tabName3 = item.name;
      if (this.org_type === "city") {
        this.getCityImplementationinfo(item.label);
      } else {
        this.getImplementationinfo(item.label);
      }
    },
    getDataList() {
      if (this.org_type === "city") {
        this.getCityImplementationinfo(item.label);
      } else {
        this.getImplementationinfo(item.label);
      }
    },
    searchFun() {
      this.tableData.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData.pageNum = 1;
      this.tableData.pageNum = val;
      this.getDataList();
    },
    toDetail(scope) {
      console.log(scope);
      this.detail.info = scope.row;
      this.detail.show = true;
    },
    toDetail_1(scope) {
      console.log("详情1");
      this.detail.show_1 = true;
    },
    toDetail_2(scope) {
      console.log("详情2");
      this.detail.show_2 = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    init() {
      let vm = this;
      this.$nextTick(() => {
        // 柱状图
        let chartDom1 = document.getElementById("echarts-box1");
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          grid: {
            height: 200,
            top: 20,
            left: 42,
          },
          xAxis: {
            type: "category",
            data: vm.tu_1.name,
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: "solid",
                color: "#DDDDDD", //轴线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#999999", //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: vm.tu_1.list,
              type: "bar",
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: "none", //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: "#5BB0FF" },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart1.setOption(option1);

        // 柱状图
        let chartDom2 = document.getElementById("echarts-box2");
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          grid: {
            height: 200,
            top: 20,
            left: 42,
          },
          xAxis: {
            type: "category",
            data: vm.tu_2.name,
            axisLine: {
              //坐标线
              lineStyle: {
                type: "solid",
                color: "#DDDDDD", //轴线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#999999", //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: vm.tu_2.list,
              type: "bar",
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: "none", //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: "#00DAA3" },
                  ]),
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);
      });
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 189px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.Homeboxtop_nav_tab {
  span {
    padding-bottom: 15px;
  }
}
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
.header-item-title {
  font-size: 18px;
  color: #333;
  display: flex;
  align-items: center;
  .circle {
    width: 8px;
    height: 8px;
    display: inline-block;
    background: #4991e1;
    border-radius: 50%;
    margin-right: 10px;
  }
}
header {
  width: 100%;
  height: 390px;
  display: flex;
  .header-item {
    width: 50%;
    .unit {
      position: absolute;
      left: 14px;
      top: 100px;
      color: #aaaaaa;
      font-size: 12px;
    }
    .header-item-text {
      font-size: 14px;
      color: #666;
      padding-left: 20px;
      margin-top: 5px;
    }
  }
  #echarts-box1,
  #echarts-box2 {
    width: 590px;
    height: 300px;
  }
}
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #409eff;
  background: #ffffff;
}
::v-deep .el-radio-button .el-radio-button__inner {
  height: 32px;
  padding: 8px;
  color: #999999;
}
.m-l {
  margin-left: 20px;
}
.m-t {
  margin-top: 20px;
}
.m-b {
  margin-bottom: 20px;
}
.header_num {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: space-between;
  .header-item {
    width: calc(50% - 50px);
    border: 1px solid #eee;
    text-align: center;
    margin-right: 50px;
    margin-bottom: 20px;
    padding: 20px;

    .bigTitle {
      font-weight: bold;
      font-size: 48px;
      color: #fff;
    }
    .cont {
      font-size: 18px;
      color: #fff;
    }
    .header-item-smallTitle {
      display: flex;
      align-items: center;
      font-size: 18px;
      height: 22px;
      color: #333;
      margin: 20px 30px;
      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }
    .header-item-box {
      margin-top: 10px;
      .box-right {
        display: flex;
        justify-content: center;
        .mr {
          margin-right: 60px;
        }
        div {
          width: 100%;
        }
        p {
          width: 100%;
          font-size: 14px;
          text-align: center;
          color: #999;
        }
        .box-blue {
          font-weight: bold;
          margin-bottom: 5px;
          font-size: 20px;
          color: #4794e8;
        }
      }
    }
  }
}
.flex {
  display: flex;
  align-items: center;
}
</style>
